import React from 'react';
import ScoreCell from './ScoreCell';

export default function ReportColumn({
  report,
  reportKey,
  displayedQuestions,
  openedDay,
  popupPosition,
  setPopupPosition,
  getLogGroup,
  getBackgroundColor,
  getCellColor,
  getCellValue,
  renderCommentPopup,
  timeConvert,
}) {
  return (
    <div className="report">
      {!!openedDay && <div className="score">
        {getLogGroup(report)}
      </div>}
      {displayedQuestions.map(question => (
        <ScoreCell
          key={question}
          cellKey={`${reportKey}${question}`}
          question={question}
          response={report.responsesMap[question]}
          report={report}
          popupPosition={popupPosition}
          setPopupPosition={setPopupPosition}
          getBackgroundColor={getBackgroundColor}
          getCellColor={getCellColor}
          getCellValue={getCellValue}
          renderCommentPopup={renderCommentPopup}
        />
      ))}
      <div className="report">
        <div className="score">
          {timeConvert(report.timeSpend)}
        </div>
      </div>
    </div>
  )
}
